import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import { useAppSelector } from '@/hooks/redux-hooks';
import Snackbar from '@/uikit/Snackbar/Snackbar';

const SnackProvider: FC<PropsWithChildren> = ({ children }) => {
  const { snacks } = useAppSelector((state) => state.snackReducer);

  return (
    <>
      {snacks.map((snack, i) => (
        <Snackbar
          key={snack.id}
          {...snack}
          style={{ transform: `translateY(${i * 60}px)` }}
        >
          {snack.children}
        </Snackbar>
      ))}
      {children}
    </>
  );
};

export default SnackProvider;
